import { z } from "zod";

// Parâmetros de busca das rotas, à parte do router para as páginas os usarem sem import circular.
export const BuscaLogin = z.object({ volta: z.string().optional() });
export const BuscaFichas = z.object({ modulo: z.string().optional(), status: z.string().optional(), q: z.string().optional() });
export const BuscaNovaFicha = z.object({ modulo: z.string().optional() });
export const BuscaFato = z.object({ fonte: z.string().optional() });
